import { ApplicationState } from "core/app";
import * as monitoring from "./system/monitoring";

export interface PageList {
    apiUrl: string;
    webUrl: string,
    menu: string,
    title: string;
    apiType: string;
    response: string;
    dto: string;
    parameters: string;
    dateSteps: string;
    getDefaultToDateTime(applicationState: ApplicationState): Date;
    filterFields?: FilterField[];
}
export interface FilterField {
    title: string;
    parameter: string;
    type: string;
    options?: FilterOption[];
}
export interface FilterOption {
    title: string;
    value: string;
}



export function sortParameters(list: string[]): string[] {
    const parameterOrder = ["fromUtc", "toUtc", "skip", "take", "filter"];
    return list.sort((a, b) => {
        if (parameterOrder.indexOf(a) === -1 && parameterOrder.indexOf(b) === -1) return (a < b) ? -1 : (a > b) ? 1 : 0;
        if (!parameterOrder.includes(a)) return 1; //if not in the parameterOrder, move down
        if (!parameterOrder.includes(b)) return -1; //if not in the parameterOrder, move down
        if (parameterOrder.indexOf(a) < parameterOrder.indexOf(b)) return -1;
        if (parameterOrder.indexOf(b) < parameterOrder.indexOf(a)) return 1;
        return 0;
    });
};